export const DEFAULT_THREAD_MESSAGES_LIMIT = 20;
